import { Routes } from '@angular/router';
import { TripsPage } from './trips.page';
import { unsavedChangesGuard } from '../guards/unsaved-changes.guard';
import { v2On } from '../v2/ui-v2.guard';


export const tripsRoutes: Routes = [
    {
        path: 'trips',
        component: TripsPage,
        children: [
            {
                path: '',
                redirectTo: 'list',
                pathMatch: 'full'
            },
            // v2 versions share the URL of the current pages and are picked by the v2 switch.
            {
                path: 'add',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/add-trip-v2.page').then( m => m.AddTripV2Page)
            },
            {
                path: 'list',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/list-trips-v2.page').then( m => m.ListTripsV2Page)
            },
            {
                path: 'add',
                loadComponent: () => import('./add-trip/add-trip.page').then( m => m.AddTripPage)
            },
            {
                path: 'list',
                loadComponent: () => import('./list-trips/list-trips.page').then( m => m.ListTripsPage)
            },
            {
                path: 'select-markers',
                loadComponent: () => import('./select-markers/select-markers.page').then( m => m.SelectMarkersPage),
                canDeactivate: [unsavedChangesGuard]
            },
            {
                path: 'detail',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/trip-detail-v2.page').then( m => m.TripDetailV2Page)
            },
            {
                path: 'detail',
                loadComponent: () => import('./trip-detail/trip-detail.page').then( m => m.TripDetailPage)
            },
            {
                path: 'edit',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/edit-trip-v2.page').then( m => m.EditTripV2Page)
            },
            {
                path: 'edit',
                loadComponent: () => import('./edit-trip/edit-trip.page').then( m => m.EditTripPage)
            },
            {
                path: 'stats',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/trip-stats-v2.page').then( m => m.TripStatsV2Page)
            },
            {
                path: 'stats',
                loadComponent: () => import('./trip-stats/trip-stats.page').then( m => m.TripStatsPage)
            },
            {
                path: 'live-wall',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/live-wall-v2.page').then( m => m.LiveWallV2Page)
            },
            {
                path: 'live',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/live-trips-v2.page').then( m => m.LiveTripsV2Page)
            },
            {
                path: 'live',
                loadComponent: () => import('./live-trips/live-trips.page').then( m => m.LiveTripsPage)
            },
            {
                path: 'live-detail',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/live-trip-detail-v2.page').then( m => m.LiveTripDetailV2Page)
            },
            {
                path: 'live-detail',
                loadComponent: () => import('./live-trip-detail/live-trip-detail.page').then( m => m.LiveTripDetailPage)
            },
            {
                path: 'route-detail',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/trip-route-detail-v2.page').then( m => m.TripRouteDetailV2Page)
            },
            {
                path: 'route-detail',
                loadComponent: () => import('./trip-route-detail/trip-route-detail.page').then( m => m.TripRouteDetailPage)
            },
            {
                path: 'logs',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/trip-logs-v2.page').then( m => m.TripLogsV2Page)
            },
            {
                path: 'logs',
                loadComponent: () => import('./trip-logs/trip-logs.page').then( m => m.TripLogsPage)
            },
            {
                path: 'auto-plan',
                loadComponent: () => import('./auto-plan/auto-plan.page').then( m => m.AutoPlanPage)
            },
            {
                path: 'manifest',
                canMatch: [v2On],
                loadComponent: () => import('../v2/pages/trips/trip-manifest-v2.page').then( m => m.TripManifestV2Page),
                canDeactivate: [unsavedChangesGuard]
            },
            {
                path: 'manifest',
                loadComponent: () => import('./trip-manifest/trip-manifest.page').then( m => m.TripManifestPage),
                canDeactivate: [unsavedChangesGuard]
            }
        ]
    }
];